import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import {PatientsService} from '../patients.service';
import {ExamsService} from '../exams.service';
import { LoginService } from '../login.service';

@Component({
    selector: 'app-send-link',
    templateUrl: './send-link.component.html',
    styleUrls: ['./send-link.component.scss'],
    standalone: false
})
export class SendLinkComponent implements OnInit {
  @Input('exam') exam;
  @Input('isForm') isForm;
  @Input('concent') concent;

  @Output() closed = new EventEmitter<null>();

  phone: string;
  error='';
  sending=false;
  sent = false;
  channel: 'whatsapp' | 'sms' = 'sms';

  constructor(private pat: PatientsService, public examS: ExamsService, public ls:LoginService) { }

  // AAAS mode: DICOM-configured clinic, regular exam link (consent forms stay legacy).
  // Sends report PDF + DICOM media via the AAAS worker (WhatsApp or SMS, async).
  get aaasMode(): boolean {
    return !this.isForm && this.examS.dicomConfigured;
  }

  ngOnInit() {
    let mobile = this.pat.getPat().Mobile;
    let p2 = this.pat.getPat().Phone;
    if(mobile)
      this.phone = mobile;
    else if(p2)
      this.phone=p2;
  }

  close(){
    this.closed.emit();
  }

  sendLink(){
    this.sending = true;
    if(this.phone)
      this.phone = this.phone.replace(/[^0-9-]/gm,'');
    if(this.isForm){
      this.examS.sendLinkConcent(this.phone, this.concent).subscribe((data)=>{
        if(data["status"] != "ok"){
          this.error = data["status"];
          this.sending=false;
        }
        else{
          this.sent= true;
          setTimeout(()=>{
            this.closed.emit();
          },2000);
          
        }
      },(error)=>{
        this.error = error;
        this.sending=false;
      })
    }else if(this.aaasMode){
      this.examS.sendPatientLink(this.phone, this.channel).subscribe((data)=>{
        if(data["status"] != "ok"){
          this.error = data["status"];
          this.sending=false;
        }
        else{
          this.sent= true;
          this.ls.linksent+1;
          setTimeout(()=>{
            this.closed.emit();
          },2500);
        }
      },(error)=>{
        this.error = error?.error?.status || error?.error?.error || 'Failed to send link';
        this.sending=false;
      })
    }else{

      this.examS.sendLink(this.phone,).subscribe((data)=>{
        if(data["status"] != "ok"){
          this.error = data["status"];
          this.sending=false;
        }
        else{
          this.sent= true;
          this.ls.linksent+1;
          setTimeout(()=>{
            this.closed.emit();
          },2000);
          
        }
      },(error)=>{
        this.error = error;
        this.sending=false;
      })
    }
  }

}
